import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import API from '../backend/api';

const GmailTest = () => {
  const { user } = useAuth();
  const [oauthUrl, setOauthUrl] = useState('');
  const [error, setError] = useState('');
  const [redirectUris, setRedirectUris] = useState([]);
  const [selectedUri, setSelectedUri] = useState('');

  useEffect(() => {
    if (user) {
      testOAuthConfiguration();
    }
  }, [user]);

  const testOAuthConfiguration = async () => {
    try {
      const response = await API.get('/gmail/oauth/');
      setOauthUrl(response.data.authorization_url);
      setError('');
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to get OAuth URL');
    }
  };

  const handleTestRedirect = () => {
    if (oauthUrl) {
      window.location.href = oauthUrl;
    }
  };

  const handleManualRedirectUri = (uri) => {
    setSelectedUri(uri);
    // You can implement manual redirect URI testing here
  };

  if (!user) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <h2>Gmail OAuth Test</h2>
        <p>Please log in first to test Gmail OAuth configuration.</p>
      </div>
    );
  }

  return (
    <div style={{ padding: '2rem', maxWidth: '800px', margin: '0 auto' }}>
      <h2>Gmail OAuth Configuration Test</h2>
      
      <div style={{ marginBottom: '2rem' }}>
        <h3>Current Configuration</h3>
        <p><strong>OAuth URL:</strong></p>
        <code style={{ 
          display: 'block', 
          background: '#f5f5f5', 
          padding: '1rem', 
          borderRadius: '4px',
          wordBreak: 'break-all',
          marginBottom: '1rem'
        }}>
          {oauthUrl || 'Not generated yet'}
        </code>
        
        {oauthUrl && (
          <button 
            onClick={handleTestRedirect}
            style={{
              background: '#4285f4',
              color: 'white',
              border: 'none',
              padding: '0.75rem 1.5rem',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '1rem'
            }}
          >
            Test OAuth Flow
          </button>
        )}
      </div>

      <div style={{ marginBottom: '2rem' }}>
        <h3>Redirect URI Information</h3>
        <p>The OAuth URL above uses the redirect URI: <code>http://localhost:3000</code></p>
        <p>This redirect URI must be added to your Google Cloud Console.</p>
        
        <div style={{ 
          background: '#fff3cd', 
          border: '1px solid #ffeaa7', 
          borderRadius: '4px', 
          padding: '1rem',
          marginTop: '1rem'
        }}>
          <h4>To fix the redirect_uri_mismatch error:</h4>
          <ol>
            <li>Go to <a href="https://console.cloud.google.com/" target="_blank" rel="noopener noreferrer">Google Cloud Console</a></li>
            <li>Select your project: <code>job-app-tracker-473902</code></li>
            <li>Go to "APIs & Services" → "Credentials"</li>
            <li>Find OAuth 2.0 Client ID: <code>71212262947-8q5rthehmssihceffjtjd510pt1smm9k.apps.googleusercontent.com</code></li>
            <li>Add <code>http://localhost:3000</code> to "Authorized redirect URIs"</li>
            <li>Save changes</li>
          </ol>
        </div>
      </div>

      {error && (
        <div style={{ 
          background: '#f8d7da', 
          border: '1px solid #f5c6cb', 
          borderRadius: '4px', 
          padding: '1rem',
          color: '#721c24'
        }}>
          <h4>Error:</h4>
          <p>{error}</p>
        </div>
      )}

      <div style={{ marginTop: '2rem' }}>
        <h3>Alternative Solutions</h3>
        <p>If you can't modify the Google Cloud Console, let me know what redirect URIs are currently configured, and I can update the code to use one of them.</p>
      </div>
    </div>
  );
};

export default GmailTest;
